/**
 * AI-disclosure constants shared by the static (browser) and motion (worker)
 * export paths. The visible copy and the machine-readable IPTC value are
 * defined once here so every renderer emits an identical disclosure.
 */

export const DISCLAIMER_TEXT = "Contains AI-generated content";

/**
 * IPTC "Digital Source Type" controlled-vocabulary IRIs.
 * See https://cv.iptc.org/newscodes/digitalsourcetype/
 *
 * `compositeSynthetic` ("Mix or composite of several elements, at least one of
 * which is Generative AI") is what our exported ads are: an AI-generated image
 * composited with typed copy, vector shapes, and brand assets. It's the value
 * we embed.
 *
 * `trainedAlgorithmicMedia` (the whole asset is AI-generated) is kept for a
 * future content-dependent path — e.g. an export that is nothing but a
 * generated image. It's also the value Meta documents for its "AI info" label.
 */
export const IPTC_DIGITAL_SOURCE_TYPE_COMPOSITE_SYNTHETIC =
  "http://cv.iptc.org/newscodes/digitalsourcetype/compositeSynthetic";

export const IPTC_DIGITAL_SOURCE_TYPE_TRAINED_ALGORITHMIC_MEDIA =
  "http://cv.iptc.org/newscodes/digitalsourcetype/trainedAlgorithmicMedia";

export const DISCLAIMER_POSITIONS = [
  "bottom-left",
  "bottom-right",
  "top-left",
  "top-right",
] as const;

export const DEFAULT_DISCLAIMER_POSITION = "bottom-left";

/**
 * Default visible-overlay typography. Shared by the overlay renderer and the
 * brand-defaults config, so a brand that hasn't customized its disclosure font
 * is seeded with exactly what the renderer produces today.
 */
export const DISCLAIMER_FONT_SIZE = 14;
export const DISCLAIMER_FONT_FAMILY =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
